import React, { lazy } from "react";
import PrivateRoute from "../../components/PrivateRoute";
import { Routes } from "../../context/App";

const Messages = lazy(() => import("../../pages/Messages"));

interface MessagesProps {
  route: typeof Routes.MESSAGES;
  path: string;
  exact: boolean;
}

const MessagesRoute: React.FC<MessagesProps> = (props) => {
  const { route, path, exact } = props;
  return (
    <PrivateRoute path={path} route={route} exact={exact} Component={Messages} />
  );
};

export default MessagesRoute;
